import { motion } from 'framer-motion'

interface ShopFlyerGalleryProps {
    title: string
    images: string[]
}

const ShopFlyerGallery = ({ title, images }: ShopFlyerGalleryProps) => {
    return (
        <div className="mb-12 sm:mb-16 mt-8 w-full">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6 }}
                className="text-center mb-8"
            >
                <h2 className="text-2xl sm:text-3xl font-bold text-gradient mb-3">{title}</h2>
                <div className="w-16 h-1 bg-gradient-to-r from-primary-600 to-primary-400 mx-auto rounded-full"></div>
            </motion.div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 w-full max-w-7xl mx-auto">
                {images.map((src, index) => (
                    <motion.div
                        key={src + index}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-50px" }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        className="group relative rounded-2xl overflow-hidden shadow-2xl bg-dark-800 border-2 border-dark-700/50 hover:border-primary-500/50 transition-all duration-300 transform"
                    >
                        {/* Aspect ratio container for typical vertical flyers (usually ~ 1:1.4 or taller) */}
                        <div className="relative aspect-[3/4] sm:aspect-[2/3] w-full overflow-hidden">
                            <img
                                src={src}
                                alt={`Werbeangebot ${index + 1}`}
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                loading="lazy"
                            />
                            {/* Subtle gradient overlay to make it look premium */}
                            <div className="absolute inset-0 bg-gradient-to-t from-dark-950/40 to-transparent pointer-events-none"></div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    )
}

export default ShopFlyerGallery
